import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockContainer from '../BlockContainer';

import css from './BlockHomeStep.module.css';

// Wine sparkle with step number badge
const SparkleNumber = ({ number }) => (
  <div className={css.badgeWrapper}>
    <svg
      width="64"
      height="64"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={css.badgeSvg}
    >
      <path
        d="M24 12C17.7782 12 12 17.7782 12 24C12 17.7782 6.22183 12 0 12C6.22183 12 12 6.22183 12 0C12 6.22183 17.7782 12 24 12Z"
        fill="#8C265C"
      />
    </svg>
    <span className={css.badgeNumber}>{String(number)}</span>
  </div>
);

const BlockHomeStep = props => {
  const {
    blockId,
    className,
    rootClassName,
    title,
    text,
    callToAction,
    options,
    alignment,
    stepNumber,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const hasTextFields = hasDataInFields([title, text, callToAction], options);

  const alignmentClass = {
    left: css.alignLeft,
    center: css.alignCenter,
    right: css.alignRight,
  }[alignment];

  return (
    <BlockContainer id={blockId} className={classes}>
      {stepNumber != null ? <SparkleNumber number={stepNumber} /> : null}
      {hasTextFields ? (
        <div className={classNames(css.content, alignmentClass)}>
          <Field data={title} options={options} />
          <Field data={text} options={options} />
          {callToAction?.content ? (
            <Field data={callToAction} options={options} />
          ) : null}
        </div>
      ) : null}
    </BlockContainer>
  );
};

export default BlockHomeStep;
